import { render, staticRenderFns } from "./edit-text-dialog.vue?vue&type=template&id=25cb6edc&scoped=true&"
import script from "./edit-text-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-text-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cb6edc",
  null
  
)

export default component.exports